import { makeStyles } from "@/utils"
import { colors } from "@/styles/colors"

type HeaderStyleProps = {
	variant: "inbox" | "console"
}

const useStyles = (props: HeaderStyleProps) => makeStyles((theme) => ({
	header: {
		display: "flex",
		alignItems: "center",
		padding: theme.spacing(2.5, 2, 1.25, 2.5)
	},
	headerExpanded: {
		flexDirection: "row",
		justifyContent: "space-between",
		gap: 0
	},
	headerCollapsed: {
		flexDirection: "column",
		justifyContent: "center",
		gap: theme.spacing(1.5)
	},
	collapseToggle: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		color: props.variant === "console" ? colors.gray[0] : colors.gray[500],
		padding: theme.spacing(0.5),
		borderRadius: theme.spacing(0.5),
		"&:hover": { color: props.variant === "console" ? colors.gray[200] : colors.gray[400] }
	}
}))(props)

export default useStyles
